import React, { useEffect, useRef, useState } from "react";

import api from "../../services/api";

import HeaderV2 from "../../components/headerV2";
import CircleData from "../../components/nova-home/circle-data";
import CropManagement from "../../components/nova-home/crop-management";
import TreatedArea from "../../components/nova-home/treated-area";
import LastRecipesHome from "../../components/nova-home/last-recipes-home";

import { store } from "react-notifications-component";

import IconEmail from '../../assets/icons/icon-mail-gray.png';
import IconProfile from '../../assets/icons/icon-user-with-border-gray.png';
import IconZap from '../../assets/icons/icon-whatsapp-gray.png';
import ButtonList from "../../components/button-list";
import LastRecipesAgronomist from "../../components/last-recipes";
import TreatedAreaAgronomist from "../../components/treated-area-agronomist";
import FunctionBlockedOverlay from "../../components/functionBlocked";
import Modal from "../../components/modal/modalFuncaoBloqueadaImpressaoFe";

import * as S from './stylesV2';
import { TaglineM } from "../../styles/stylesTypography";
import { theme } from "../../styles/theme";
import Recipe from "../../components/nova-home/recipe";

export const USER = "@userinfo";

const isFunctionBlocked = (user) => {
    const planId = user?.contrato?.agro_plan_config?.agro_plan_id;
    const diasRestante = Number(user?.contrato?.dias_restante ?? 0);
    return (
        planId === 7 ||
        planId === 6 ||
        planId === 4 ||
        (planId === 1 && diasRestante <= 0)
    );
};

const getUserFromStorage = () => {
    try {
        return JSON.parse(localStorage.getItem("@userinfo"));
    } catch {
        return null;
    }
};

const EditAgronomos = ({ ...props }) => {
    const getId = window.location.pathname.split("/")[2];
    const [dataAgronomo, setDataAgronomo] = useState("");
    const [dataCreas, setDataCreas] = useState("");
    const [fazendas, setFazendas] = useState([]);
    const [creaOptions, setCreaOptions] = useState([]);
    const [selectedCrea, setSelectedCrea] = useState(null);
    // add states to support LastRecipesAgronomist props
    const [allRecipes, setAllRecipes] = useState([]);
    const [culturas, setCulturas] = useState([]);
    const [culturaId, setCulturaId] = useState("");
    const [emitiuReceita, setEmitiuReceita] = useState(false);

    const [openModalTrue, setOpenModalTrue] = useState(false);
    const receitasEmitidasBlockedRef = useRef(null);
    const areaTratadaBlockedRef = useRef(null);

    const isBlocked = isFunctionBlocked(getUserFromStorage());

    const getDataAgronomos = async () => {
        const response = await api.get(`/agronomos/${getId}`);
        setDataAgronomo(response.data.data);
        setEmitiuReceita(response.data.emitiu_receita);
    }

    const getCreas = async () => {
        const response = await api.get(`/agronomos/${getId}/creas`);
        setDataCreas(response.data.data[0]);
    }

    // fetch last recipes for the agronomist, filtered by cultura when set
    const getAllRecipesAgronomist = async () => {
        try {
            const response = await api.get(
                `/receitas/historico/responsavel/${getId}/${
                culturaId || "*"
                }?limit=30&offset=0`
            );
            if (response.status === 200) {
                setAllRecipes(response.data?.data || []);
                setCulturas(response.data?.culturas || []);
            }
        } catch (error) {
            setAllRecipes([]);
        }
    };

    useEffect(() => {
        getDataAgronomos();
        getCreas();
        getAllRecipesAgronomist();
    }, []);

    useEffect(() => {
        // Sempre refaz a busca quando culturaId muda (inclui limpar para "*")
        getAllRecipesAgronomist();
    }, [culturaId]);

    const selectCrea = (e) => {
        setSelectedCrea(e);
    }

    const selectFarm = (e) => {
        setFazendas(e);
    }

    useEffect(() => {
        if (dataAgronomo && Array.isArray(dataAgronomo.creas) && dataAgronomo.creas.length > 0) {
            const opts = dataAgronomo.creas
                .filter((c) => c?.status === 1)
                .map(c => {
                    const tipoLabel = c.tipo === 'visto' ? 'VISTO' : c.tipo === 'crea' ? 'CREA' : 'CFTA';
                    const estadoLabel = c.estado ? `${c.estado}:` : '';
                    return {
                        value: c.id || c.crea,
                        label: `${tipoLabel}-${estadoLabel}${c.crea}`,
                    };
                });
            setCreaOptions(opts);
            if (!selectedCrea) {
                setSelectedCrea(opts[0]);
            }
        }
    }, [dataAgronomo]);

    return (
        <>
            <HeaderV2 title={dataAgronomo.nome}/>

            <S.PageContent>
                <S.HeaderBar withOutOption={creaOptions.length === 0}>
                    {creaOptions.length > 0 && (
                        <S.LeftColumnSmall>
                            <ButtonList
                                id="creas"
                                width="100%"
                                legend={dataAgronomo.nome}
                                options={creaOptions}
                                onSelected={(e) => selectCrea(e)}
                                value={selectedCrea}
                                dataAgronomo={true}
                                widthImg={24}
                                heightImg={24}
                            />
                        </S.LeftColumnSmall>
                    )}

                    <S.IconActions>
                        <a
                            href={
                                dataAgronomo.whatsapp
                                ? `https://wa.me/${dataAgronomo.whatsapp.replace(
                                    /\D/g,
                                    ""
                                )}`
                                : undefined
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => e.stopPropagation()}
                            >
                            <img src={IconZap} alt="Ícone de WhatsApp" style={{ width: "16px", height: "16px" }} />
                        </a>

                        <a
                            href={
                                dataAgronomo.email
                                ? `mailto:${dataAgronomo.email}`
                                : undefined
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                opacity: dataAgronomo.email !== "" ? 1 : 0.5,
                                cursor: dataAgronomo.email !== "" ? "pointer" : "not-allowed"
                            }}
                            >
                            <img src={IconEmail} alt="Ícone de e-mail" style={{ width: "16px", height: "16px" }} />
                        </a>

                        <S.Button2 onClick={() => window.location.href = `/agronomos/edit/${getId}`}>
                            <img src={IconProfile} alt="Ícone de perfil" />
                        
                            <TaglineM color={theme.colors.gray.Cinza_2} fontWeight={800}>
                                Dados RT
                            </TaglineM>
                        </S.Button2>
                    </S.IconActions>
                </S.HeaderBar>

                {allRecipes.length > 0 && culturas.length > 0 ? (
                    <LastRecipesAgronomist 
                        allRecipes={allRecipes}
                        culturas={culturas}
                        updateCultura={(e) => setCulturaId(e)}
                    />
                ): (
                    <Recipe/>
                )}
                
                <S.MainGrid>
                    <S.LeftColumn>
                        {isBlocked ? (
                            <>
                                <div ref={receitasEmitidasBlockedRef} style={{ width: "100%" }}>
                                    <TreatedAreaAgronomist
                                        agronomoId={Number(getId)}
                                        textReport="Receitas emitidas"
                                        optionDefault="Receitas Emitidas"
                                        optionsDateFilter={[
                                            { value: '1', label: 'Últimos 7 dias' },
                                            { value: '2', label: 'Últimos 30 dias' },
                                            { value: '3', label: 'Últimos 12 meses' },
                                        ]}
                                    />
                                </div>

                                <FunctionBlockedOverlay
                                    visible
                                    mode="cover-parent"
                                    attachTo={receitasEmitidasBlockedRef}
                                    ctaType="activate"
                                    onActivate={() => setOpenModalTrue(true)}
                                />
                            </>
                        ) : (
                            <TreatedAreaAgronomist
                                agronomoId={Number(getId)}
                                textReport="Receitas emitidas"
                                optionDefault="Receitas Emitidas"
                                optionsDateFilter={[
                                    { value: '1', label: 'Últimos 7 dias' },
                                    { value: '2', label: 'Últimos 30 dias' },
                                    { value: '3', label: 'Últimos 12 meses' },
                                ]}
                            />
                        )}

                        {isBlocked ? (
                            <>
                                <div ref={areaTratadaBlockedRef} style={{ width: "100%" }}>
                                    <TreatedAreaAgronomist
                                        agronomoId={Number(getId)}
                                        textReport="Área tratada (ha)"
                                        optionDefault="Área tratada (ha)"
                                        optionsDateFilter={[
                                            { value: '1', label: 'Últimos 7 dias' },
                                            { value: '2', label: 'Últimos 30 dias' },
                                            { value: '3', label: 'Últimos 12 meses' },
                                        ]}
                                    />
                                </div>

                                <FunctionBlockedOverlay
                                    visible
                                    mode="cover-parent"
                                    attachTo={areaTratadaBlockedRef}
                                    ctaType="activate"
                                    onActivate={() => setOpenModalTrue(true)}
                                />
                            </>
                        ) : (
                            <TreatedAreaAgronomist
                                agronomoId={Number(getId)}
                                textReport="Área tratada (ha)"
                                optionDefault="Área tratada (ha)"
                                optionsDateFilter={[
                                    { value: '1', label: 'Últimos 7 dias' },
                                    { value: '2', label: 'Últimos 30 dias' },
                                    { value: '3', label: 'Últimos 12 meses' },
                                ]}
                            />
                        )}
                    </S.LeftColumn>

                    <S.RightSidebar>
                        <CircleData
                            NoSelecet={true}
                            selectImage={false}
                            dataAgronomo={dataAgronomo}
                            creaId={selectedCrea?.value}
                            marginBottom="0"
                        />

                        <CropManagement agronomoId={Number(getId)} />
                    </S.RightSidebar>
                </S.MainGrid>

                {openModalTrue ? (
                    <Modal show={openModalTrue} onHide={() => setOpenModalTrue(false)} />
                ) : null}
            </S.PageContent>
        </>
    );
}

export default EditAgronomos;
